import React from "react";
import { Box, Typography, FormControlLabel, Checkbox } from "@mui/material";
import { DialogComponent } from "../../atom";
import TextButtonComponet from "../../atom/Buttons/TextButton";

export const FolderActionConfirmationDialog = ({
  folderConfirm,
  setFolderConfirm,
  onConfirm,
}) => {
  if (!folderConfirm) return null;

  const title = folderConfirm.type === "delete" ? "DELETE FOLDER" : "CHANGE FOLDER STATUS";
  const message =
    folderConfirm.type === "delete"
      ? "This action will affect the quiz inside it. Are you sure you want to delete this folder?"
      : "This action will affect the quiz inside it. Are you sure you want to change the status of this folder?";

  return (
    <DialogComponent
      isShowCloseButton={true}
      title={title}
      open={Boolean(folderConfirm)}
      maxwidth="sm"
      onClose={() => setFolderConfirm(null)}
    >
      <Box sx={{ px: 3, pb: 3, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography
          sx={{
            color: "#2D3945",
            fontSize: 16,
            lineHeight: 1.5,
            marginTop: 2,
            textAlign: "center",
          }}
        >
          {message}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(folderConfirm?.understood)}
                onChange={(e) =>
                  setFolderConfirm((prev) =>
                    prev ? { ...prev, understood: e.target.checked } : prev
                  )
                }
                sx={{
                  color: "#9834F0",
                  "&.Mui-checked": { color: "#9834F0" },
                }}
              />
            }
            label="I understand"
            sx={{
              margin: 0,
              "& .MuiFormControlLabel-label": {
                fontWeight: 600,
                fontSize: 16,
                color: "#2D3945",
              },
            }}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
          <TextButtonComponet
            text="Cancel"
            classStyle="btn btn-secondary"
            onButtonClick={() => setFolderConfirm(null)}
          />
          <TextButtonComponet
            text="OK"
            isDisabled={!folderConfirm?.understood}
            onButtonClick={onConfirm}
          />
        </Box>
      </Box>
    </DialogComponent>
  );
};